import React, { useState } from 'react';
import Education from './Education';
import Skills from './Skills';
import Projects from './Projects';
import Experience from './Experience';
import './styles/MainContent.css';

const MainContent = () => {
	const [activeSection, setActiveSection] = useState('education');

	const renderContent = () => {
		switch (activeSection) {
			case 'education':
				return <Education />;
			case 'skills':
				return <Skills />;
			case 'experience':
				return <Experience />;
			case 'projects':
				return <Projects />;
			default:
				return <Education />;
		}
	};

	return (
		<div className="main-container mt-5">
			<nav
				className={`sidebar bg-transparent border-right border-light ${
					activeSection === 'skills' ? 'fixed-width' : ''
				}`}
			>
				<ul>
					<li
						className="list-item"
						onClick={() => setActiveSection('education')}
					>
						Education
					</li>
					<li className="list-item" onClick={() => setActiveSection('skills')}>
						Skills
					</li>
					<li
						className="list-item"
						onClick={() => setActiveSection('experience')}
					>
						Experience
					</li>
					<li
						className="list-item"
						onClick={() => setActiveSection('projects')}
					>
						Projects
					</li>
				</ul>
			</nav>
			<div className="content-container">{renderContent()}</div>
		</div>
	);
};

export default MainContent;
